import React from 'react';

import Typography from 'components/ui/Typography';

import css from './NotificationCounter.module.scss';
interface Props {
    count: number | string;
}
const NotificationCounter: React.FC<Props> = ({ count }) => (
    <div className={css.badge}>
        <Typography style="BadgeBold" color="white">
            {count}
        </Typography>
    </div>
);

export default NotificationCounter;
